/**
 * Every plural form a language needs, so a count never falls back to English.
 * i18next picks key_one / key_few / key_many... by the language's plural rules;
 * Slovak, Polish, Russian, Arabic and others have forms the files may lack (2-4 in
 * Slovak is "few"), and a missing form went to English ("3 tasks" in the middle of
 * Slovak). A missing form takes the language's own _other (or _one) text instead.
 */
const SUFFIXES = ['zero', 'one', 'two', 'few', 'many', 'other'];

const categories = (lng) => {
  try {
    return new Intl.PluralRules(lng).resolvedOptions().pluralCategories;
  } catch {
    return ['one', 'other'];
  }
};

export const fillPlurals = (resources, lng) => {
  const needed = categories(lng);
  const visit = (node) => {
    if (!node || typeof node !== 'object') return;
    const bases = new Set();
    Object.keys(node).forEach((key) => {
      const m = key.match(/^(.*)_(zero|one|two|few|many|other)$/);
      if (m && typeof node[key] === 'string') bases.add(m[1]);
      else if (typeof node[key] === 'object') visit(node[key]);
    });
    bases.forEach((base) => {
      const source = node[`${base}_other`] ?? node[`${base}_one`] ?? SUFFIXES.map((s) => node[`${base}_${s}`]).find(Boolean);
      needed.forEach((cat) => {
        if (node[`${base}_${cat}`] === undefined) node[`${base}_${cat}`] = source;
      });
    });
  };
  visit(resources);
  return resources;
};
